import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';
import { useCurrentMilestone } from '../../hooks/useCurrentMilestone';
import { useEventUsersQuery } from '../../hooks/useEventUsersQuery';
import { useNextMilestone } from '../../hooks/useNextMilestone';

export const usePaymentForSomeone = () => {
  const navigate = useNavigate();
  const { data: currentEventData, loading } = useCurrentEventQuery();
  const { data: currentUserData } = useCurrentUserQuery();
  const { data: unpaidEventUsersData } = useEventUsersQuery(
    currentEventData?.currentEvent?.id ?? null,
    false,
  );
  const [pickedUserId, setPickedUserId] = useState<string | null>(null);

  const currentEvent = useMemo(
    () => currentEventData?.currentEvent ?? null,
    [currentEventData],
  );

  const currentUser = useMemo(
    () => currentUserData?.currentUser ?? null,
    [currentUserData],
  );
  const hasGivenInformation =
    currentUser?.firstname && currentUser?.lastname && currentUser?.birthdate;

  const currentMilestone = useCurrentMilestone(currentEvent?.milestones ?? []);
  const nextMilestone = useNextMilestone(currentEvent?.milestones ?? []);

  const onGoToDashboard = () => {
    navigate('/dashboard');
  };

  const onGoToPayment = () => {
    navigate('/payment');
  };

  const unpaidUsers = useMemo(
    () => unpaidEventUsersData?.eventUsers ?? [],
    [unpaidEventUsersData],
  );

  return {
    hasGivenInformation,
    loading,
    currentEvent,
    currentMilestone,
    nextMilestone,
    onGoToDashboard,
    onGoToPayment,
    unpaidUsers,
    pickedUserId,
    setPickedUserId,
  };
};
